// Recovered compiled webpack factory 77609. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "applyFlightData", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(30637),
    a = r(60543);
  function o(e, t, r, o, i) {
    let { tree: s, seedData: l, head: u, isRootRender: c } = o;
    if (null === l) return !1;
    if (c) {
      let a = l[1];
      ((r.loading = l[3]),
        (r.rsc = a),
        (r.prefetchRsc = null),
        (0, n.fillLazyItemsTillLeafWithHead)(e, r, t, s, l, u, i));
    } else
      ((r.rsc = t.rsc),
        (r.prefetchRsc = t.prefetchRsc),
        (r.parallelRoutes = new Map(t.parallelRoutes)),
        (r.loading = t.loading),
        (0, a.fillCacheWithNewSubTreeData)(e, r, t, o, i));
    return !0;
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
